import { registrationEmailUtmParameters } from "../send/sendRegisterEmail"
import moment, { Moment } from "moment"
import "moment/locale/cs"
import { generateButtonPdfVoucherLink } from "./subDefinitions/generateButtonPdfVoucherLink"
import { generateEmailCallToActionButton, generateEmailParagraph, generateEmailText, spaceDivider } from "../generateEmailParagraph"
import { thankYou } from "./subDefinitions/emailComponents"

moment.locale("cs")

const emailDefinition1RegisterIntoOnlineProjectDaysSubject = "Potvrzení registrace do projektového dne, Vzdělání budoucnosti"

export const emailDefinition1RegisterIntoOnlineProjectDays = (
  courseTitle: string,
  when: string,
  courseDetailPageUrl: string,
  downloadPdfVoucherUrl?: string
): { body: string; subject: string } => ({
  body: `
    ${generateEmailParagraph("Dobrý den, ")}
    
    ${generateEmailParagraph(
      `s radostí Vám oznamujeme, že jste úspěšně zaregistrovaný(á) do online projektového dne <strong>"${courseTitle}"</strong>, která byla provedena dne ${moment().format(
        "l"
      )}. Chystáme pro Vás zajímavý program, a těšíme se na Vaši účast.`
    )}
    
    ${generateEmailText(`<strong>Datum a čas konání:</strong>`)}
    ${generateEmailParagraph(when)}
    
    ${generateEmailText(`<strong>Forma:</strong>`)}
    ${generateEmailParagraph(`Online setkání skrze platformu Google Meet.`)}    
        
    ${generateEmailParagraph(
      "Projektový den se bude konat online. Na tuto e-mailovou adresu zašleme URL link skrze který se budeš moci připojit k pořádané akci."
    )}
    
    ${spaceDivider}
    
    ${generateEmailParagraph(`Více informací o kurzu naleznete na našich webových stránkách.`)}
    
    ${generateEmailCallToActionButton("Více informací o kurzu", "Více informací o kurzu", `${courseDetailPageUrl}${registrationEmailUtmParameters}`)}
    
    ${generateButtonPdfVoucherLink(downloadPdfVoucherUrl)}
    
    ${thankYou}
    `,
  subject: emailDefinition1RegisterIntoOnlineProjectDaysSubject
})
